export default "__VITE_ASSET__BrmfhFIh__"